import React, { useEffect } from 'react'
import { Box, Typography, Skeleton, Container } from '@mui/material';
import { useSelector } from 'react-redux';

const UserProfile = ({message = "Welcome back"}) => {
  const { profile } = useSelector((state) => state.userAuth);
  const userName = profile?.user_name;
  const phone = profile?.phone;
  const shouldShowPhone = phone && !phone.includes("CROBO");
  
  return (
    <Box
      sx={{
        my: 2,
        position: "relative",
      }}
    >
      {userName ? (
        <>
          {message && (
            <Typography
              variant="body2"
              sx={{
                color: (theme) => theme.palette.mode === 'dark' 
                  ? theme.palette.primary.light 
                  : theme.palette.custom.teal,
                fontWeight: 500,
                mb: 1,
              }}
            >
              {message}
            </Typography>
          )}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: "bold",
                  color: (theme) => theme.palette.mode === 'dark' 
                    ? theme.palette.common.white 
                    : theme.palette.custom.oxfordBlue,
                  fontSize: { xs: '1.5rem', sm: '1.75rem' },
                }}
              >
                {userName}
              </Typography>
            </Box>
          </Box>

          {shouldShowPhone && (
            <Typography
              variant="body2"
              sx={{
                color: (theme) => theme.palette.mode === 'dark'
                  ? theme.palette.text.secondary
                  : theme.palette.custom.oxfordBlue,
                opacity: 0.8,
              }}
            >
              {phone}
            </Typography>
          )}
        </>
      ) : (
        <>
          {message && <Skeleton width={100} height={20} sx={{ mb: 1 }} />}
          <Skeleton width={200} height={32} />
          {shouldShowPhone && <Skeleton width={100} height={20} sx={{ mb: 1 }} />}
        </>
      )}
    </Box>
  );
}

export default UserProfile;